import { BarChart3 } from 'lucide-react';

export default function Analytics() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <BarChart3 className="h-16 w-16 text-muted-foreground/40 mb-4" />
      {/* Spacing lives on the sibling, so the h1 itself stays margin-free and
          identical to every other page heading. */}
      <h1 className="text-xl sm:text-2xl font-bold tracking-tight">Analytics Dashboard</h1>
      <p className="text-muted-foreground mt-2">Coming soon — detailed analytics and insights will appear here.</p>
    </div>
  );
}
